"use client";
import { apiCallsModalStore } from "../modalStore";
import { ApiCallModalType, ModalClickHandler, ModalDataType } from "../types";

const ZKModals: Record<string, ModalDataType> = {
  limit: {
    type: ApiCallModalType.ERROR,
    data: {
      title: "Перевищено ліміт вартості!",
      description:
        "Шановний клієнте! Вартість вашого полісу страхування перевищує 40 000 грн. Згідно рекомендацій НБУ, перед укладанням полісу необхідно надати документи для проходження фінансового моніторингу. Зверніться, будь ласка, до найближчого відділення ПЗУ Україна або замовте консультацію.",
      onCancel: () => {},
      onSubmit: () => {},
    },
  },
  // agreement: {
  //   type: ApiCallModalType.AGREEMENT,
  //   data: {
  //     description:
  //       "На вашу електронну адресу надійшов лист із пропозицією, де ви можете перевірити актуальність усіх даних та ознайомитись із загальними умовами страхування додаткових продуктів, якщо ви їх обирали. Для ознайомлення із зареєстрованою пропозицією {{ОСЦПВВНТЗ}} перейдіть за посиланням нижче.",
  //   },
  // },
};

export const openLimitZKModal = ({
  onCancel,
  onSubmit,
}: {
  onCancel: ModalClickHandler;
  onSubmit: ModalClickHandler;
}) => {
  apiCallsModalStore.getState().open(ZKModals.limit.type, {
    ...ZKModals.limit.data,
    onCancel,
    onSubmit,
  });
};

// const AutoZakhistModals: Record<string, ModalDataType> = {
//   revision: {
//     type: ApiCallModalType.INFO,
//     data: {
//       title: "Необхідний огляд авто!",
//       description:
//         "Для підписання даного договору страхування ваш автомобіль необхідно оглянути та сфотографувати. Даний процес може відбуватись дистанційно, немає необхідності їхати в офіс компанії. Для роз'яснення та узгодження подальших кроків найближчим часом з Вами зв'яжеться менеджер.",
//       onSubmit: () => {},
//       submitText: "до магазину",
//     },
//   },
//   // agreement: {
//   //   type: ApiCallModalType.AGREEMENT,
//   //   data: {
//   //     description:
//   //       "На вказану Вами електрону адресу надійшов лист з пропозицією, де Ви можете перевірити актуальність усіх даних та ознайомитись із загальними умовами страхування",
//   //   },
//   // },
// };

const avtocivilModals: Record<string, ModalDataType> = {
  // franchiseTarif: {
  //   type: ApiCallModalType.INFO,
  //   data: {
  //     title: "Тариф змінено!",
  //     description:
  //       "Система виявила, що протягом минулого року у вас був страховий випадок тому, цього року немає можливості придбати поліс страхування з франшизою {{0 грн.}} Оновлена вартість пакету послуг: {{1 111 грн.}}",
  //     buttonsLayout: "horizontal",
  //     onCancel: () => {},
  //     onSubmit: () => {},
  //   },
  // },
  tarifChange: {
    type: ApiCallModalType.INFO,
    data: {
      title: "Тариф змінено!",
      description:
        "Увага! Тариф змінено. Система виявила, що протягом минулого року у вас був страховий випадок. Оновлена вартість пакету послуг: {{finalPremium}}",
      buttonsLayout: "horizontal",
      onCancel: () => {},
      onSubmit: () => {},
    },
  },
  // agreement: {
  //   type: ApiCallModalType.AGREEMENT,
  //   data: {
  //     description:
  //       "На вказану вами електрону адресу надійшов лист з пропозицією, де ви можете перевірити актуальність усіх даних та ознайомитись із загальними умовами страхування додаткових продуктів, якщо ви їх обирали. Для ознайомлення із зареєстрованою пропозицією ВОСЦПВВНТЗ (Автоцивілка) перейдіть за посиланням нижче.",
  //   },
  // },
};

// export const openAutocivilFranchizeTarifModal = ({
//   onCancel,
//   onSubmit,
//   description,
// }: {
//   onCancel: ModalClickHandler;
//   onSubmit: ModalClickHandler;
//   description:string
// }) => {
//   apiCallsModalStore.getState().open(avtocivilModals.franchiseTarif.type, {
//     ...avtocivilModals.franchiseTarif.data,
//     description,
//     onCancel,
//     onSubmit,
//   });
// };
export const openAutocivilTarifChangeModal = ({
  description,
  onCancel,
  onSubmit,
}: {
  description?: string;
  onCancel: ModalClickHandler;
  onSubmit: ModalClickHandler;
}) => {
  apiCallsModalStore.getState().open(avtocivilModals.tarifChange.type, {
    ...avtocivilModals.tarifChange.data,
    onCancel,
    onSubmit,
  });
};

export const openTourizmTarifChangeModal = ({
  description,
  onCancel,
  onSubmit,
}: {
  description?: string;
  onCancel: ModalClickHandler;
  onSubmit: ModalClickHandler;
}) => {
  apiCallsModalStore.getState().open(tourizmModals.tarifChange.type, {
    ...tourizmModals.tarifChange.data,
    onCancel,
    onSubmit,
  });
};

const tourizmModals: Record<string, ModalDataType> = {
  delete: {
    type: ApiCallModalType.ERROR,
    data: {
      title: "Видалити туриста?",
      description:
        "Шановний клієнте, ви дійсно бажаєте видалити даного туриста зі списку застрахованих?",
      cancelText: "НІ",
      submitText: "Так",
    },
  },
  limit: {
    type: ApiCallModalType.ERROR,
    data: {
      title: "Неможливо додати туриста!",
      description:
        "Шановний клієнте, в одному договорі страхування ви можете застрахувати не більше десяти туристів. Якщо вам необхідно застрахувати ще осіб, будь ласка, оформіть для них окремий поліс.",
      cancelText: "назад",
      submitText: "гаразд",
    },
  },
  // agreement: {
  //   type: ApiCallModalType.AGREEMENT,
  //   data: {
  //     description: `На вказану вами електрону адресу надійшов лист з "Чернеткою" вашого договору страхування, де ви можете перевірити актуальність усіх даних.`,
  //   },
  // },
  tarifChange: {
    type: ApiCallModalType.INFO,
    data: {
      title: "Тариф змінено!",
      description:
        "Шановний клієнте, звертаємо Вашу увагу, що вартість договору страхування оновилася у зв’язку зі зміною параметра, що впливає на розрахунок тарифу. Перевірте, будь ласка, внесені дані та продовжуйте процес оформлення.",
      buttonsLayout: "horizontal",
      onCancel: () => {},
      onSubmit: () => {},
    },
  },
};

export const openTouristDeleteModal = ({
  onCancel,
  onSubmit,
}: {
  onCancel: ModalClickHandler;
  onSubmit: ModalClickHandler;
}) => {
  apiCallsModalStore.getState().open(tourizmModals.delete.type, {
    ...tourizmModals.delete.data,
    onCancel,
    onSubmit,
  });
};

export const openTouristLimitModal = ({
  onCancel,
  onSubmit,
}: {
  onCancel: ModalClickHandler;
  onSubmit: ModalClickHandler;
}) => {
  apiCallsModalStore.getState().open(tourizmModals.limit.type, {
    ...tourizmModals.limit.data,
    onCancel,
    onSubmit,
  });
};

const contractModals: Record<string, ModalDataType> = {
  contractExist: {
    type: ApiCallModalType.INFO,
    data: {
      title: "Увага!",
      description: `Згідно даних ЦБД МТСБУ станом на сьогодні знайдено діючий договір страхування №{{checkContractNumber}}. Страхова компанія: {{insurerName}}, {{insurerPhoneNumber}}, {{insurerEmail}}, {{insurerPostAddress}} Транспортний засіб: {{plateNumber}}, {{autoDescription}}. Якщо це договір, що укладений попереднім власником, то згідно п. 20-1.2 ЗУ "Про ОСЦПВВНТЗ" він має право звернутись до зазначено вище Страховика для дострокового припинення діючого договору та повернення коштів за невикористаний період.`,
      buttonsLayout: "horizontal",
      cancelText: "Мапа відділень",
      withCross: true,
      onCancel: () => {},
      onSubmit: () => {},
    },
  },
};

export const openContractExistModal = ({
  description,
  onCancel,
  onSubmit,
}: {
  description?: string;
  onCancel?: ModalClickHandler;
  onSubmit?: ModalClickHandler;
}) => {
  apiCallsModalStore.getState().open(contractModals.contractExist.type, {
    ...contractModals.contractExist.data,
    description:
      description ||
      (contractModals.contractExist.data as any).description ||
      "",
    onCancel,
    onSubmit,
  });
};
